import { UserAppSettings } from "@/api/fetchUserAppSettings/types";

/** The stage name (userAppSettings.companyStage.name) of a member before their Executive Perspective. */
export const PRE_EP_STAGE_NAME = "Pre-EP";

/** Where a Pre-EP member's Hub+ lives. */
export const PRE_EP_HOME = "/pre-ep";

/** The active company is Pre-EP. */
export const isPreEpCompany = (settings: UserAppSettings | null): boolean =>
  settings?.companyStage?.name === PRE_EP_STAGE_NAME;

/**
 * A Pre-EP company's own user: their whole Hub+ is the full-screen Pre-EP
 * pages. CertainPath staff switched into the company keep the regular app.
 */
export const isPreEpMember = (settings: UserAppSettings | null): boolean =>
  isPreEpCompany(settings) && settings?.isCertainPathEmployee === false;
